import { useMutation } from '@tanstack/react-query';

import { setAuth, setConsumerUUID } from '../../app/consumerInfoSlice';
import { useAppDispatch } from '../../app/hooks';
import { store } from '../../app/store';
import { showError } from '../api';
import { login, LoginError, LoginRequest, LoginResponse } from './login.api';

export default function useLogin() {
  const dispatch = useAppDispatch();
  const auth = store.getState().consumerInfoSelector.auth;
  return useMutation<LoginResponse, LoginError, LoginRequest>({
    mutationFn: login,
    onSuccess: (data) => {
      dispatch(setConsumerUUID(data.consumerUUID));
      dispatch(setAuth({ ...auth, requestID: data.requestID }));
    },
    onError: () => {
      showError(dispatch);
    },
  });
}

// TODO: should be sending resend=true or something
export const useResendOtp = useLogin;
